module.exports = __webpack_public_path__ + "img/fp-backdrop.d9d738bf.png";